import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { BaseManagementActions } from '../../store/base-management/base-management.actions';
import { selectBaseAccess } from '../../store/base-management/base-management.selectors';
import { selectUserPrivileges } from '../../store/user/auth/user-auth.selectors';
import { APP_PATHS, firstAllowedAppRoute } from '../constants/app-config.constants';
import { BYPASS_PRIVILEGE_CHECKS } from '../constants/feature-flags.constants';

/** Lets a user into Base Management only when the Scheduler reports view or write access. */
export const baseManagementGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  if (BYPASS_PRIVILEGE_CHECKS) {
    store.dispatch(BaseManagementActions.loadAccess());
    return true;
  }

  return store.select(selectBaseAccess).pipe(
    tap((access) => {
      if (!access) store.dispatch(BaseManagementActions.loadAccess());
    }),
    filter((access) => access !== null),
    take(1),
    switchMap((access) => {
      if (access.allowed) return of(true);
      return store.select(selectUserPrivileges).pipe(
        take(1),
        map((privileges) =>
          router.parseUrl(
            firstAllowedAppRoute(privileges, { skipPrefix: `/${APP_PATHS.BASE_MANAGEMENT}` })
          )
        )
      );
    })
  );
};
